import React from "react";
import { LandingPageScreen } from "../../../../app/screens/landing-page-screen";
import { PrivateRouteDefinition } from "../../../../infecto-lms-webapp/router/interfaces";

export const LANDING_PAGE_PATH = "/webseite/:urlParam";

export const LandingPagesRoutes: PrivateRouteDefinition[] = [
	{
		path: LANDING_PAGE_PATH,
		component: <LandingPageScreen />,
	},
];
